/* tslint:disable */
import {
  Payee
} from '../index';

declare var Object: any;
export interface PayeeFraudChecklistInterface {
  "payee_id": number;
  "vendor"?: boolean;
  "vendor_name"?: string;
  "vendor_address_1"?: string;
  "vendor_address_2"?: string;
  "vendor_address_3"?: string;
  "vendor_address_4"?: string;
  "vendor_address_city"?: string;
  "vendor_address_zip_code"?: string;
  "vendor_address_state"?: string;
  "product_type_name"?: string;
  "target_customer_msia"?: boolean;
  "target_customer_foreign"?: boolean;
  "emarket"?: boolean;
  "emarket_open_loop"?: boolean;
  "emarket_closed_loop"?: boolean;
  "scan"?: boolean;
  "scan_by_system"?: boolean;
  "scan_manually"?: boolean;
  "sell_imitation"?: boolean;
  "control_imitation"?: any;
  "control_imitation_mechanism"?: any;
  "storage"?: boolean;
  "storage_address_1"?: string;
  "storage_address_2"?: string;
  "storage_address_3"?: string;
  "storage_address_4"?: string;
  "storage_address_city"?: string;
  "storage_address_zip_code"?: string;
  "storage_address_state"?: string;
  "product_ship_to_msia"?: boolean;
  "product_ship_to_oversea"?: boolean;
  "handle_shipment_by_same_com"?: boolean;
  "handle_shipment_by_seller"?: boolean;
  "current acquirer bank"?: string;
  "dispute_pic_name"?: string;
  "dispute_pic_position"?: string;
  "dispute_pic_email"?: string;
  "dispute_pic_contact"?: string;
  "dispute_process_steps"?: any;
  "dispute_refund_steps"?: any;
  "dispute_refund_days_offered"?: number;
  "dispute_refund_days_process"?: number;
  "require_register"?: boolean;
  "limit_tx"?: boolean;
  "capture_ip"?: boolean;
  "blocking_ip"?: boolean;
  "track_tx"?: boolean;
  "block_blacklist_tx"?: boolean;
  "track_suspicious_tx"?: boolean;
  "criteria_mitigate_fraud"?: any;
  "id"?: number;
  "created_at"?: Date;
  "updated_at"?: Date;
  "deletedAt"?: Date;
  "isDeleted": boolean;
  payee?: Payee;
}

export class PayeeFraudChecklist implements PayeeFraudChecklistInterface {
  "payee_id": number;
  "vendor": boolean;
  "vendor_name": string;
  "vendor_address_1": string;
  "vendor_address_2": string;
  "vendor_address_3": string;
  "vendor_address_4": string;
  "vendor_address_city": string;
  "vendor_address_zip_code": string;
  "vendor_address_state": string;
  "product_type_name": string;
  "target_customer_msia": boolean;
  "target_customer_foreign": boolean;
  "emarket": boolean;
  "emarket_open_loop": boolean;
  "emarket_closed_loop": boolean;
  "scan": boolean;
  "scan_by_system": boolean;
  "scan_manually": boolean;
  "sell_imitation": boolean;
  "control_imitation": any;
  "control_imitation_mechanism": any;
  "storage": boolean;
  "storage_address_1": string;
  "storage_address_2": string;
  "storage_address_3": string;
  "storage_address_4": string;
  "storage_address_city": string;
  "storage_address_zip_code": string;
  "storage_address_state": string;
  "product_ship_to_msia": boolean;
  "product_ship_to_oversea": boolean;
  "handle_shipment_by_same_com": boolean;
  "handle_shipment_by_seller": boolean;
  "current acquirer bank": string;
  "dispute_pic_name": string;
  "dispute_pic_position": string;
  "dispute_pic_email": string;
  "dispute_pic_contact": string;
  "dispute_process_steps": any;
  "dispute_refund_steps": any;
  "dispute_refund_days_offered": number;
  "dispute_refund_days_process": number;
  "require_register": boolean;
  "limit_tx": boolean;
  "capture_ip": boolean;
  "blocking_ip": boolean;
  "track_tx": boolean;
  "block_blacklist_tx": boolean;
  "track_suspicious_tx": boolean;
  "criteria_mitigate_fraud": any;
  "id": number;
  "created_at": Date;
  "updated_at": Date;
  "deletedAt": Date;
  "isDeleted": boolean;
  payee: Payee;
  constructor(data?: PayeeFraudChecklistInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PayeeFraudChecklist`.
   */
  public static getModelName() {
    return "PayeeFraudChecklist";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PayeeFraudChecklist for dynamic purposes.
  **/
  public static factory(data: PayeeFraudChecklistInterface): PayeeFraudChecklist{
    return new PayeeFraudChecklist(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PayeeFraudChecklist',
      plural: 'payeeFraudChecklists',
      path: 'payeeFraudChecklists',
      idName: 'id',
      properties: {
        "payee_id": {
          name: 'payee_id',
          type: 'number'
        },
        "vendor": {
          name: 'vendor',
          type: 'boolean'
        },
        "vendor_name": {
          name: 'vendor_name',
          type: 'string'
        },
        "vendor_address_1": {
          name: 'vendor_address_1',
          type: 'string'
        },
        "vendor_address_2": {
          name: 'vendor_address_2',
          type: 'string'
        },
        "vendor_address_3": {
          name: 'vendor_address_3',
          type: 'string'
        },
        "vendor_address_4": {
          name: 'vendor_address_4',
          type: 'string'
        },
        "vendor_address_city": {
          name: 'vendor_address_city',
          type: 'string'
        },
        "vendor_address_zip_code": {
          name: 'vendor_address_zip_code',
          type: 'string'
        },
        "vendor_address_state": {
          name: 'vendor_address_state',
          type: 'string'
        },
        "product_type_name": {
          name: 'product_type_name',
          type: 'string'
        },
        "target_customer_msia": {
          name: 'target_customer_msia',
          type: 'boolean'
        },
        "target_customer_foreign": {
          name: 'target_customer_foreign',
          type: 'boolean'
        },
        "emarket": {
          name: 'emarket',
          type: 'boolean'
        },
        "emarket_open_loop": {
          name: 'emarket_open_loop',
          type: 'boolean'
        },
        "emarket_closed_loop": {
          name: 'emarket_closed_loop',
          type: 'boolean'
        },
        "scan": {
          name: 'scan',
          type: 'boolean'
        },
        "scan_by_system": {
          name: 'scan_by_system',
          type: 'boolean'
        },
        "scan_manually": {
          name: 'scan_manually',
          type: 'boolean'
        },
        "sell_imitation": {
          name: 'sell_imitation',
          type: 'boolean'
        },
        "control_imitation": {
          name: 'control_imitation',
          type: 'any'
        },
        "control_imitation_mechanism": {
          name: 'control_imitation_mechanism',
          type: 'any'
        },
        "storage": {
          name: 'storage',
          type: 'boolean'
        },
        "storage_address_1": {
          name: 'storage_address_1',
          type: 'string'
        },
        "storage_address_2": {
          name: 'storage_address_2',
          type: 'string'
        },
        "storage_address_3": {
          name: 'storage_address_3',
          type: 'string'
        },
        "storage_address_4": {
          name: 'storage_address_4',
          type: 'string'
        },
        "storage_address_city": {
          name: 'storage_address_city',
          type: 'string'
        },
        "storage_address_zip_code": {
          name: 'storage_address_zip_code',
          type: 'string'
        },
        "storage_address_state": {
          name: 'storage_address_state',
          type: 'string'
        },
        "product_ship_to_msia": {
          name: 'product_ship_to_msia',
          type: 'boolean'
        },
        "product_ship_to_oversea": {
          name: 'product_ship_to_oversea',
          type: 'boolean'
        },
        "handle_shipment_by_same_com": {
          name: 'handle_shipment_by_same_com',
          type: 'boolean'
        },
        "handle_shipment_by_seller": {
          name: 'handle_shipment_by_seller',
          type: 'boolean'
        },
        "current acquirer bank": {
          name: 'current acquirer bank',
          type: 'string'
        },
        "dispute_pic_name": {
          name: 'dispute_pic_name',
          type: 'string'
        },
        "dispute_pic_position": {
          name: 'dispute_pic_position',
          type: 'string'
        },
        "dispute_pic_email": {
          name: 'dispute_pic_email',
          type: 'string'
        },
        "dispute_pic_contact": {
          name: 'dispute_pic_contact',
          type: 'string'
        },
        "dispute_process_steps": {
          name: 'dispute_process_steps',
          type: 'any'
        },
        "dispute_refund_steps": {
          name: 'dispute_refund_steps',
          type: 'any'
        },
        "dispute_refund_days_offered": {
          name: 'dispute_refund_days_offered',
          type: 'number'
        },
        "dispute_refund_days_process": {
          name: 'dispute_refund_days_process',
          type: 'number'
        },
        "require_register": {
          name: 'require_register',
          type: 'boolean'
        },
        "limit_tx": {
          name: 'limit_tx',
          type: 'boolean'
        },
        "capture_ip": {
          name: 'capture_ip',
          type: 'boolean'
        },
        "blocking_ip": {
          name: 'blocking_ip',
          type: 'boolean'
        },
        "track_tx": {
          name: 'track_tx',
          type: 'boolean'
        },
        "block_blacklist_tx": {
          name: 'block_blacklist_tx',
          type: 'boolean'
        },
        "track_suspicious_tx": {
          name: 'track_suspicious_tx',
          type: 'boolean'
        },
        "criteria_mitigate_fraud": {
          name: 'criteria_mitigate_fraud',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "created_at": {
          name: 'created_at',
          type: 'Date'
        },
        "updated_at": {
          name: 'updated_at',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date'
        },
        "isDeleted": {
          name: 'isDeleted',
          type: 'boolean',
          default: false
        },
      },
      relations: {
        payee: {
          name: 'payee',
          type: 'Payee',
          model: 'Payee',
          relationType: 'belongsTo',
                  keyFrom: 'payee_id',
          keyTo: 'id'
        },
      }
    }
  }
}
